import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetTodosQuery } from "../features/api/apiSlice";
import { addCount } from "../features/filter/filterSlice";
import Todo from "./Todo";

export default function TodoList() {
  const { data, isLoading, isError } = useGetTodosQuery();
  const { colors, status } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  console.log(data);
  let count = 0;
  useEffect(() => {
    data?.forEach((element) => {
      if (element.completed === false) {
        count++;
        dispatch(addCount(count));
      }
    });
  }, [data, dispatch, count]);
  let content = null;
  if (!isError && isLoading) {
    content = <p>Loding....</p>;
  }
  if (!isError && !isLoading && data.length === 0) {
    content = <p>No todos</p>;
  }
  if (isError && !isLoading) {
    content = <p> There is some error</p>;
  }
  if (!isError && !isLoading && data.length > 0) {
    content = data
      .filter((todo) => {
        if (colors.length > 0) {
          return colors.includes(todo.color);
        } else {
          return true;
        }
      })
      .filter((todo) => {
        if (status !== "") {
          if (status === "all") {
            return true;
          }
          if (status === "incomplete") {
            return todo.completed === false;
          }
          if (status === "complete") {
            return todo.completed === true;
          }
        }
        return true;
      })
      .map((todo) => <Todo key={todo.id} todo={todo} />);
  }
  return (
    <div class="mt-1 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {content}
    </div>
  );
}
